import smoothscroll from 'smoothscroll-polyfill';
// import IntersectionObserver from './_main/IntersectionObserver';

import { isIE } from './utility';
import { CFG } from './config';
import {
    Dropdown,
    Hamburger,
    Accordion,
    ScrollImageChanger,
    ScrollCurrentChecker,
    ScrollTriggerClass,
    ScrollManager,
    ModalVideo,
    AnchorScroll
} from './_main';
// import HamburgerMenu from './_main/HamburgerMenu';

// import DropdownMenu from './_main/DropdownMenu';
// import LoadMore from './_main/LoadMore';
// import CookieAlert from './_main/CookieAlert';
// import Validation from './_main/Validation';
// import HeightSet from './_main/HeightSet';
// import Pagetop from './_main/Pagetop';

// import MaterialsSlides from './_home/MaterialsSlides';
// import ModalVideo from './_movies/ModalVideo';

// home
import {
    Opening,
    PointerFollow,
    // VisualSlides,
    ScrollMessageAnimation,
    ScrollEndlessAnimation,
    ScrollTitleAnimation,
    GallerySlides,
    ScrollSlides,
    StoriesSlides
} from './_home'

// archives
import { PostsLoading } from './_my-growth';

{
    smoothscroll.polyfill();

    const domScrollTriggerClass = document.querySelectorAll('[data-js="stc"]');
    if (domScrollTriggerClass) new ScrollTriggerClass(domScrollTriggerClass);  

    const domScrollImageChanger = document.querySelectorAll('[data-js="cic"]');
    if (domScrollImageChanger.length !== 0) new ScrollImageChanger(domScrollImageChanger);  

    const domScrollCurrentChecker = document.querySelectorAll('[data-js="scc"]');
    if (domScrollCurrentChecker) new ScrollCurrentChecker(domScrollCurrentChecker);

    const domHamburger = document.querySelector('[data-js="trigger"]');
    if (domHamburger) new Hamburger(domHamburger);

    const domAnchorScroll = [...document.querySelectorAll('a[href^="#"]')];
    if ( domAnchorScroll ) {
        domAnchorScroll.forEach(el => {
            new AnchorScroll(el);
        });
    }

    const domAccordion = document.querySelectorAll('[data-js="accordion"]');
    if (domAccordion) {
        [...domAccordion].forEach(el=>{
            new Accordion(el);
        })
    }

    const domDropdown = document.querySelectorAll('[data-js="dropdown"]');
    if (domDropdown) {
        [...domDropdown].forEach(el=>{
            new Dropdown(el);
        })
    }

    const domModalVideo = document.querySelectorAll('[data-js="modal-video"]');
    if (domModalVideo) {
        [...domModalVideo].forEach(el=>{
            new ModalVideo(el);
        })
    }

    const domScroller = document.querySelector('[data-scroller]');
    if (domScroller) new ScrollManager(domScroller);
}

// {
//     const domModalVideos = document.querySelectorAll('[data-js="modal-trigger"]');
//     if (domModalVideos) {
//         new ModalVideo(domModalVideos);
//     }
// }

{

    const domOpening = document.querySelector('[data-js="opening"]');
    if (domOpening) new Opening(domOpening);
    
    // ポインター追従
    const domPointerFollow = document.querySelector('[data-js="pointer"]');
    if (domPointerFollow) {
        const pointerFollow = new PointerFollow();
        const mql = window.matchMedia('screen and (min-width: 768px)');
        let checkBreakPoint = function (_mql) {
            if (!_mql.matches) {
                // SP
                pointerFollow.destroy();
            } else {
                // PC
                pointerFollow.init();
            }
        };
        // ブレイクポイントの瞬間に発火
        mql.addListener(checkBreakPoint);
        // 初回チェック
        checkBreakPoint(mql);
    }
    
    // const domVisualSlides = document.querySelector('[data-js="visual-slide"]');
    // if (domVisualSlides) new VisualSlides(domVisualSlides);

    const domScrollMessageAnimation = document.querySelector('[data-js="scrollShow"]');
    if (domScrollMessageAnimation) new ScrollMessageAnimation(domScrollMessageAnimation);

    const domScrollEndlessAnimation = document.querySelector('[data-js="endless"]');
    if (domScrollEndlessAnimation) new ScrollEndlessAnimation(domScrollEndlessAnimation);

    const domScrollTitleAnimation = document.querySelectorAll('[data-js="scroll-title"]');
    if (domScrollTitleAnimation) {
        [...domScrollTitleAnimation].forEach(el=>{
            new ScrollTitleAnimation(el);
        })
    }

    const domGallerySlides = document.querySelector('[data-js="gallery-slide"]');
    if (domGallerySlides) new GallerySlides(domGallerySlides);

    const domMoviesCrosstalkSlides = document.querySelector('[data-js="movies-crosstalk-slide"]');
    if (domMoviesCrosstalkSlides) new ScrollSlides(domMoviesCrosstalkSlides);

    const domMoviesStorySlides = document.querySelector('[data-js="movies-story-slide"]');
    if (domMoviesStorySlides) new ScrollSlides(domMoviesStorySlides);

    const domStoriesSlides = document.querySelector('[data-js="stories-slide"]');
    if (domStoriesSlides) new StoriesSlides(domStoriesSlides);
}

{
    const domPostsLoading = document.querySelector('[data-js="conditions-post"]');
    if( domPostsLoading ) new PostsLoading(domPostsLoading);
}
